// extracted by mini-css-extract-plugin
export default {"confirm":"confirm_confirm__9GtNi","btn":"confirm_btn__jayp0","btnContainer":"confirm_btnContainer__3WKmF","icon":"confirm_icon__80BJP"};